import moment from 'moment'

export default {
  computed: {
    bookingPaymentIsPaid () {
      return this.payment.status === 'paid' && this.payment.transaction
    },

    bookingPaymentIsUnpaid () {
      return this.payment.status === 'unpaid'
    },

    bookingPaymentIsSent () {
      return this.payment.status === 'sent'
    },

    bookingPaymentIsOnHold () {
      return this.payment.status === 'hold'
    },

    bookingPaymentIsOverdue () {
      return this.bookingPaymentIsUnpaid &&
        moment().startOf('day').isAfter(moment(this.payment.due_date, 'YYYY-MM-DD HH:mm:ss').startOf('day'))
    },

    bookingPaymentType () {
      if (this.payment.type === 'final') {
        return 'Final Payment'
      } else if (this.payment.type === 'deposit') {
        return 'Deposit'
      } else if (this.payment.type === 'full') {
        return 'Full Payment'
      }
    }
  }
}
